import React, { useState } from "react";
import { ITombolaTopProps } from "../interfaces/ITombolaTopProps";

export const TombolaTop = (props: ITombolaTopProps) => {
  const { Render, isEndState = false } = props;
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const onSubmit = () => {
    setIsButtonDisabled(true);
  };

  return <Render onSubmit={onSubmit} isButtonDisabled={isButtonDisabled} isEndState={isEndState} />;
};
